/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {correctActivityItem} from '../api'

export const useMutationCorrectActivityItem = createReactQueryMutationHook('correctActivityItem', correctActivityItem)
